import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePL from '@angular/common/locales/pl';
import { provideRouter, Router } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpErrorInterceptor } from './interceptors/http-error/http-error.interceptor';
import { MessageService } from 'primeng/api';
import { AuthService } from './services/auth/auth.service';
import * as Sentry from "@sentry/angular";

registerLocaleData(localePL, 'pl');

export const appConfig: ApplicationConfig = {
  providers: [
    AuthService,
    MessageService,
    provideAnimations(),
    provideNoopAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        httpErrorInterceptor,
      ]),
    ),
    {provide: LOCALE_ID, useValue: 'pl' },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]
};
